export { formatPrice } from "../../shared/teamCurrencyFormatting";

export const toNumber = (value) => Number(value || 0);
